// extracted by mini-css-extract-plugin
export default {"space":"Review_space__X-kyH","loading":"Review_loading__DskNG","error":"Review_error__UZAor"};